import HttpRequest from "@/api/axios";
import moment from 'moment';
const axios = new HttpRequest(process.env.VUE_APP_API_BASE_URL);

export default {
    vote(params) {
        return axios.request({
            url: `sports-item-user/vote`,
            method: 'post',
            data: params
        });
    },
    getVoteDetail(id) {
        return axios.request({
            url: `sports-item-user/${id}?expand=sportsItem,sportsItemSub,userInfo`,
            method: 'get'
        });
    },
    sportsMain(data) {
        return axios.request({
            url: `match/sports`,
            method: "get",
            params:data
        });
    },
    getSportsItemRank(params) {
        return axios.request({
            url: 'sports-item/rank',
            method: 'get',
            params
        });
    },
    getMySportsItemRank(params) {
        return axios.request({
            url: 'sports-item/my-rank',
            method: 'get',
            params
        });
    },
    getMlist(params) {
        return axios.request({
            url: 'sports/mlist',
            method: 'get',
            params
        }).then((res) => {
            if (+res.status === 200) {
                let sys_time = res.sys_time;
                res.data.forEach((item) => {

                    item.start_time_show = moment(item.start_time * 1000).format(
                        'MM月DD日 HH:mm'
                    );
                    item.end_time_show = moment(item.end_time * 1000).format(
                        'MM月DD日 HH:mm'
                    );
                    item.start_time_week = moment(item.start_time * 1000).format(
                        'dd'
                    );
                    item.start_time_day = moment(item.start_time * 1000).format(
                        'DD'
                    );
                    if (!item.attended && sys_time >= item.start_time * 1 && sys_time <= item.end_time * 1) {
                        res.data.canjoin = item;
                    }
                    if(sys_time < item.start_time){
                        item.state_title = '未开始'
                        item.state = 0;
                    }else if(sys_time > item.end_time){
                        item.state_title = '已结束'
                        item.state= 2;
                    }else{
                        item.state_title = '进行中'
                        item.state=1;
                    }

                });
            }
            return res;
        });
    },
    getLinks(data) {
        return axios.request({
            url: `externallink-config/${data.id}`,
            method: "get",
            params:data
        });
    }
}